/* eslint-disable array-callback-return */
import {
  NOTIFICATION_GET_DATA,
  NOTIFICATION_GET_DATA_SUCCESS,
  NOTIFICATION_GET_DATA_FAILURE,
  NOTIFICATION_SET_PID,
  NOTIFICATION_SHOW_MODAL,
  NOTIFICATION_SET_REQUEST_PERMISSION_ID,
  NOTIFICATION_UNSET_REQUEST_PERMISSION_ID,
  ENABLE_SOCKET
} from "../constants/notification-types";
import store from "../store";
import axios from "axios";
// import { notification } from 'antd'
// import { getItem } from './PermissionAction'
// import { showComment } from './CommentAction';
import {
  ENDPOINT
  // JOBS_COMPLETE,
  // JOBS_FAILURE,
  // JOBS_SUCCESS,
  // CREATE_GROUP,
  // UPDATE_GROUP,
  // ADD_OBJECT_GROUP,
  // REMOVE_OBJECT_GROUP,
  // sendNotification,
} from "../utils/index";
/**
 * Obtiene todas las notificaciones
 * @param {*} clientId
 */
export const getNotifications = (clientId, intl) => {
  return dispatch => {
    try {
      dispatch({ type: NOTIFICATION_GET_DATA });
      const { accessToken } = store.getState().authUser.token;
      axios
        .get(`${ENDPOINT}clients/${clientId}/notifications`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`
          }
        })
        .then(resp => {
          if (resp.status === 200) {
            const _showModal = store.getState().notifications.showModal;

            dispatch({
              type: NOTIFICATION_GET_DATA_SUCCESS,
              payload: {
                toBeConfirmed: resp.data.toBeConfirmed,
                userRequests: resp.data.userRequests,
                showNotification: _showModal
                  ? false
                  : resp.data.userRequests.length > 0,
                showModal: resp.data.userRequests.length > 0
              }
            });
          } else {
            const { pid } = store.getState().notifications;
            clearInterval(pid);
            dispatch({ type: NOTIFICATION_GET_DATA_FAILURE });
          }
        })
        .catch(err => {
          const { pid } = store.getState().notifications;
          clearInterval(pid);
          dispatch({ type: NOTIFICATION_GET_DATA_FAILURE });
        });
    } catch (error) {
      const { pid } = store.getState().notifications;
      clearInterval(pid);
      dispatch({ type: NOTIFICATION_GET_DATA_FAILURE });
    }
  };
};

/**
 * Setea el pid
 * @param {*} pid
 */
export const setPid = pid => {
  return dispatch => {
    dispatch({
      type: NOTIFICATION_SET_PID,
      payload: pid
    });
  };
};

/**
 * Muestra/Oculta modal
 * @param {*} show
 */
export const showModal = show => {
  return dispatch => {
    dispatch({
      type: NOTIFICATION_SHOW_MODAL,
      payload: show
    });
  };
};

/**
 * Marca el id de request que se ira a editar en permisos, con el fin de poder enviarlo en la solicitud de cambio de permisos
 * @param {*} requestId
 */

export const setRequestIdToSend = requestId => {
  return dispatch => {
    dispatch({
      type: NOTIFICATION_SET_REQUEST_PERMISSION_ID,
      payload: requestId
    });
  };
};

/**
 * Deja desmarcado todos los id de permisos que esten marcados para ser enviados
 * @param {*} NaN
 */

export const unsetRequestIdToSend = requestId => {
  return dispatch => {
    dispatch({
      type: NOTIFICATION_UNSET_REQUEST_PERMISSION_ID,
      payload: requestId
    });
  };
};
/**
 *
 * @param {*} socketStatus
 * @author Victor Smith
 */
export const handleStatusSocket = socketStatus => {
  return dispatch => {
    dispatch({
      type: ENABLE_SOCKET,
      payload: {
        socketStatus
      }
    });
  };
};
